/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AdminRepresentativesResponse,
  GetRepresentativesParams,
  HTTPValidationError,
} from './platformapi.schemas';

import getRepresentativesMutator from '../custom-axios-instance';

/**
 * @summary Get Representatives
 */
export const getRepresentatives = (params?: GetRepresentativesParams, signal?: AbortSignal) => {
  return getRepresentativesMutator<AdminRepresentativesResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/representatives/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetRepresentativesQueryKey = (params?: GetRepresentativesParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/representatives/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetRepresentativesQueryOptions = <
  TData = Awaited<ReturnType<typeof getRepresentatives>>,
  TError = void | HTTPValidationError,
>(
  params?: GetRepresentativesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRepresentatives>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRepresentativesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRepresentatives>>> = ({ signal }) =>
    getRepresentatives(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRepresentatives>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRepresentativesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRepresentatives>>
>;
export type GetRepresentativesQueryError = void | HTTPValidationError;

export function useGetRepresentatives<
  TData = Awaited<ReturnType<typeof getRepresentatives>>,
  TError = void | HTTPValidationError,
>(
  params: undefined | GetRepresentativesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRepresentatives>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRepresentatives>>,
          TError,
          Awaited<ReturnType<typeof getRepresentatives>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRepresentatives<
  TData = Awaited<ReturnType<typeof getRepresentatives>>,
  TError = void | HTTPValidationError,
>(
  params?: GetRepresentativesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRepresentatives>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRepresentatives>>,
          TError,
          Awaited<ReturnType<typeof getRepresentatives>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRepresentatives<
  TData = Awaited<ReturnType<typeof getRepresentatives>>,
  TError = void | HTTPValidationError,
>(
  params?: GetRepresentativesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRepresentatives>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Representatives
 */

export function useGetRepresentatives<
  TData = Awaited<ReturnType<typeof getRepresentatives>>,
  TError = void | HTTPValidationError,
>(
  params?: GetRepresentativesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getRepresentatives>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRepresentativesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
